export default "__VITE_ASSET__629dc0ff__"